export interface SocialLoginWindowMessage {
  accessToken: string;
}

export const MESSAGE_TYPE = 'login_social' as const;
